import * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
} from "@/components/ui/sidebar";
import { companyInfo } from "@/config/constants";
import { navMain } from "@/config/menu";
import { NavMain } from "./nav-main";

export function AppSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="group-data-[collapsible=icon]:p-0">
        <div className="flex items-center gap-3 p-4 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:p-2">
          <img
            src="/assets/logo_icon.png"
            alt="ABT Smart Audio"
            className="w-10 h-10 rounded-md object-contain shadow-lg group-data-[collapsible=icon]:w-8 group-data-[collapsible=icon]:h-8 transition-all duration-300"
          />

          <div className="flex flex-col group-data-[collapsible=icon]:hidden transition-all duration-300">
            <h1 className="font-bold text-lg tracking-wide text-gray-800">
              {companyInfo.name}
            </h1>

            <p className="text-xs text-gray-500 font-medium">
              {companyInfo.description}
            </p>
          </div>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
    </Sidebar>
  );
}